module.exports = __webpack_public_path__ + "static/media/pink_close.9fae0fa4.svg";